import { BlogsTopicsWrapper } from "./BlogsTopicsWrapper";
import { BlogsTopicsTitle } from "./BlogsTopicsTitle";
import { BlogsTopicsContent } from "./BlogsTopicsContent";
import { BlogsTopicsContentWrapper } from "./BlogsTopicsContentWrapper";
import { BlogTopicsCoachesWrapper } from "./BlogTopicsCoachesWrapper";
import { BlogTopicsCoachesTitle } from "./BlogTopicsCoachesTitle";
import { BlogTopicsCoachesContent } from "./BlogTopicsCoachesContent";
import { BlogTopicsCoachesCards } from "./BlogTopicsCoachesCards";
import { BlogTopicsCoachesSeeMore } from "./BlogTopicsCoachesSeeMore";

export const BlogsTopics = () => {
  return (
    <BlogsTopicsWrapper>
      <BlogsTopicsTitle>Recommended Topics</BlogsTopicsTitle>
      <BlogsTopicsContentWrapper>
        <BlogsTopicsContent />
      </BlogsTopicsContentWrapper>

      <BlogTopicsCoachesWrapper>
        <BlogTopicsCoachesTitle>Who to follow</BlogTopicsCoachesTitle>

        <BlogTopicsCoachesContent>
          <BlogTopicsCoachesCards />
          <BlogTopicsCoachesSeeMore />
        </BlogTopicsCoachesContent>
      </BlogTopicsCoachesWrapper>
    </BlogsTopicsWrapper>
  );
};
